import { ISlot } from '../declarations';

export const setHours = (slot: ISlot, date: Date) => {
  let hours = 0;
  let minutes = 0;
  if (slot.time.length === 5) {
    hours = Number(slot.time.slice(0, 2));
    minutes = Number(slot.time.slice(3, 5));
  } else {
    hours = Number(('0' + slot.time).slice(0, 2));
    minutes = Number(('0' + slot.time).slice(3, 5));
  }
  date.setHours(hours, minutes);
};
